import { isUndefined } from "lodash-es";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";

class Logout extends Component {
  componentDidMount() {
    const logoutReason = localStorage.getItem("logoutReason");
    // Invalidate token server-side
    const email = localStorage.getItem("HotelEmail");
    if (email) {
      fetch(
        `${process.env.REACT_APP_SPRING_API_URL}common/logout-remove-user-token?email=${email}`,
        {
          method: "GET",
          headers: { Token: localStorage.getItem("token") },
        }
      ).catch(() => {});
    }
    localStorage.clear();
    if (logoutReason) {
      localStorage.setItem("logoutReason", logoutReason);
    }
    sessionStorage.clear();
    this.props.logout();
  }

  render() {
    const { token } = this.props;
    return token ? (
      <LayoutSplashScreen />
    ) : (
      <Redirect to="/auth/login" />
    );
  }
}

export default connect(
  ({ auth }) => ({
    token: !isUndefined(auth.token) && !isUndefined(auth.hotels),
  }),
  auth.actions
)(Logout);
